import { j as g } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as h, useMemo as y, cloneElement as S } from "react";
import { e as v } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as t } from "./tw-cn-mXgPecoF.mjs";
import { r as B } from "./rectangle-button.styles-CcWb17YW.mjs";
import { c as i } from "./index-BpNK5r1N.mjs";
const N = i(["aspect-square p-4 "], {
  variants: {
    size: {
      xLarge: "min-h-56 rounded-12",
      large: "min-h-48 rounded-8",
      medium: "min-h-40 rounded-8",
      small: "min-h-32 rounded-6"
    },
    pcSize: {
      xLarge: "pc:min-h-56 pc:rounded-12",
      large: "pc:min-h-48 pc:rounded-8",
      medium: "pc:min-h-40 pc:rounded-8",
      small: "pc:min-h-32 pc:rounded-6"
    }
  }
}), I = i("", {
  variants: {
    size: {
      xLarge: "size-32",
      large: "size-24",
      medium: "size-24",
      small: "size-20"
    },
    pcSize: {
      xLarge: "pc:size-32",
      large: "pc:size-24",
      medium: "pc:size-24",
      small: "pc:size-20"
    }
  }
}), L = h(
  ({ theme: a = "filled_primary", disabled: o = !1, size: c, ...m }, p) => {
    const { children: l, type: d = "button", icon: e, className: u, ...z } = m, n = v({
      property: c,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "xLarge" }
    }), x = B({ theme: a }), f = N({ ...n }), r = I({ ...n }), s = y(
      () => e ? S(e, {
        className: t(r, e.props.className)
      }) : null,
      [e, r]
    );
    return /* @__PURE__ */ g.jsx(
      "button",
      {
        "aria-disabled": o,
        className: t(x, f, u),
        disabled: o,
        ref: p,
        tabIndex: o ? -1 : 0,
        type: d,
        ...z,
        children: s || l
      }
    );
  }
);
L.displayName = "NDS.IconButton";
export {
  L as I
};
